import Alpine from 'alpinejs';
import 'jquery';
import 'slick-carousel';

import complaints from './components/complaints';
import video from './components/video';
import careServiceContentBlock from './components/care-service-content-block';

import headerMenu from './components/header-menu';
import reviewsCarousel from './components/reviews-carousel';
import accordion from './components/accordion';
import payment from './components/payment';
import carehomeSearch from './components/carehome-search';
import careHomesFilter from './components/carehome-filter';
import faqs from './components/faqs';
import homeCareTeamCarousel from './components/homecare-team-carousel';
import carehomeAccommodationCarousel from './components/carehome-accommodation-carousel';
import careHomeManagementBlock from './components/care-home-management-block';
import posts from './components/posts';
import events from './components/events';
import advice from './components/advice';
import carehomeDirectory from './components/carehome-directory';
import tagDescription from './components/tag-description';

import homeCareSearch from './components/home-care-search';
import callTracker from './components/call-tracker';

window.Alpine = Alpine;

document.addEventListener('alpine:init', () => {
    Alpine.data('complaints', complaints);
    Alpine.data('video', video);
    Alpine.data('careServiceContentBlock', careServiceContentBlock);
    Alpine.data('headerMenu', headerMenu);
    Alpine.data('reviewsCarousel', reviewsCarousel);
    Alpine.data('accordion', accordion);
    Alpine.data('payment', payment);
    Alpine.data('carehomeSearch', carehomeSearch);
    Alpine.data('careHomesFilter', careHomesFilter);
    Alpine.data('faqs', faqs);
    Alpine.data('homeCareTeamCarousel', homeCareTeamCarousel);
    Alpine.data('carehomeAccommodationCarousel', carehomeAccommodationCarousel);
    Alpine.data('careHomeManagementBlock', careHomeManagementBlock);
    Alpine.data('posts', posts);
    Alpine.data('events', events);
    Alpine.data('advice', advice);
    Alpine.data('carehomeDirectory', carehomeDirectory);
    Alpine.data('tagDescription', tagDescription);
    Alpine.data('homeCareSearch', homeCareSearch);
    Alpine.data('callTracker', callTracker);
});

Alpine.start();

document
    .querySelectorAll('a[href^="#"]')
    .forEach(trigger => {
        trigger.onclick = function (e) {

            let hash = this.getAttribute('href');
            if (hash.length > 1 && hash === '#enquire') return;

            e.preventDefault();

            if (hash.length > 1) {
                let target = document.querySelector(hash);
                let headerOffset = getElementHeight('#header');
                let elementPosition = target.offsetTop;
                let offsetPosition = elementPosition - headerOffset;

                if (hash === '#overview' && window.location.href.indexOf('care-homes') > -1)
                    offsetPosition = 0;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                });
            }
        };
    });

function getElementHeight(el) {
    return document.querySelector(el).offsetHeight
}

/**
 * Listen for the DOM to load & add a header offset
 */
document.addEventListener('DOMContentLoaded', function() {
    addSubHeaderOffset();
    addWebBannerOffset();

    if (window.location.href.indexOf('find-a-care-service') > -1) {
        checkMap();
    }

    if (jQuery('.btn-enquire').length > 0) {
        jQuery('.btn-enquire').css('opacity',1);
    }

});

/**
 * Watch for a resize to mobile dimensions and add a header offset
 */
window.addEventListener('resize', function(){
    if(window.innerWidth < 768){
        addSubHeaderOffset();
        addWebBannerOffset();
    }
});

/**
 * If a sub-header element is on this page, add the offset of the header to it.
 * Both elements are position sticky.
 */
function addSubHeaderOffset() {
    let header = document.querySelector('header');

    if (header !== null) {
        let subHeader = document.querySelector('#sub-header');

        if (subHeader !== null) {
            subHeader.style.top = header.offsetHeight + 'px';
        }
    }
}

function addWebBannerOffset() {
    let header = document.querySelector('header');

    if (header !== null) {
        let subHeader = document.querySelector('#sub-header');

        if (subHeader !== null) {
            let webBanner = document.querySelector('#web-banner');

            if (webBanner !== null) {
                webBanner.style.top = header.offsetHeight + webBanner.offsetHeight + 5 + 'px';
            }
        }
    }
}

function checkMap() {
    let map = document.querySelector('.map-sticky');

    if (map != null && !/Mobi|Android/i.test(navigator.userAgent)) {
        window.addEventListener('scroll', function (event) {
            if (this.scrollY > 550) {
                map.style['top'] = '190px';
            } else {
                map.style['top'] = '0';
            }
        }, false);
    }
}

//Moves viewport back to top of contact form after form submission (only on carehome pages contact form)
document.addEventListener( 'wpcf7submit', function( event ) {
    if (114 == event.detail.contactFormId) {
        const target = document.getElementById('carehome-contact-form');
        window.scrollTo({
            top: Math.round(target.getBoundingClientRect().top + document.documentElement.scrollTop - 230),
            behavior: 'smooth',
        });
    }
}, false );


let simpleCarousel = jQuery('.care-home-carousel');

if (simpleCarousel.length > 0) {
    simpleCarousel.slick({
        autoplay: false,
        autoplaySpeed: 2500,
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        nextArrow: '<div class="right"><svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 text-white hover:opacity-75 cursor-pointer" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3"><path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"></path></svg></div>',
        prevArrow: '<div class="left"><svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 text-white hover:opacity-75 cursor-pointer" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3"><path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"></path></svg></div>',
    });
}

$(document).ready(function(){
    $('.cta-carousel').slick({
            prevArrow: $('.cta-arrow-left'),
            nextArrow: $('.cta-arrow-right'),
            autoplay: true,
    });

    landingpageContactForm();
});

$('.award-carousel').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    prevArrow: $('.award-arrow-left'),
    nextArrow: $('.award-arrow-right'),
    responsive: [
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        }
    ]
});


function landingpageContactForm() {
  var $ = jQuery;
  
  var $wrapper = $('.cf7-multistep-wrapper');
  if (!$wrapper.length) {
    return;
  }
  
  var $form = $wrapper.closest('form');
  if (!$form.length) {
    return;
  }
  
  var currentStep = 1;
  var totalSteps = 4;
  

  function updateStep() {

    $form.find('.form-step').removeClass('active');
    

    $form.find('.form-step[data-step="' + currentStep + '"]').addClass('active');
    

    $form.find('.step-indicator').removeClass('active');
    $form.find('.step-indicator[data-step="' + currentStep + '"]').addClass('active');
    

    $form.find('.step-progress').attr('data-current-step', currentStep);
    

    if ($form.offset()) {
      $('html, body').animate({
        scrollTop: $form.offset().top - 100
      }, 300);
    }
  }
  

  function validateStep($step) {
    var isValid = true;
    var $errorDiv = $step.find('.step-error');
    
    $errorDiv.hide().empty();
    $step.find('.field-wrapper').removeClass('has-error');
    
    $step.find('.field-wrapper[data-required="true"]').each(function() {
      var $wrapper = $(this);
      var $inputs = $wrapper.find('input[type="radio"], input[type="checkbox"], input[type="text"], input[type="email"], input[type="tel"]');
      

      if ($inputs.filter('[type="radio"]').length > 0) {
        if (!$inputs.filter('[type="radio"]:checked').length) {
          isValid = false;
          $wrapper.addClass('has-error');
        }
      }
      
      else if ($inputs.filter('[type="checkbox"]').length > 0) {
        if (!$inputs.filter('[type="checkbox"]:checked').length) {
          isValid = false;
          $wrapper.addClass('has-error');
        }
      }
      
      else if ($inputs.filter('[type="text"], [type="email"], [type="tel"]').length > 0) {
        var $input = $inputs.filter('[type="text"], [type="email"], [type="tel"]');
        if (!$.trim($input.val())) {
          isValid = false;
          $wrapper.addClass('has-error');
        }
        

        if ($input.attr('type') === 'email' && $.trim($input.val())) {
          var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailPattern.test($input.val())) {
            isValid = false;
            $wrapper.addClass('has-error');
          }
        }
      }
    });
    

    if (!isValid) {
      $errorDiv.text('Please complete all required fields before continuing.').show();
    }
    
    return isValid;
  }
  

  $form.on('submit', function(e) {
    if (currentStep < totalSteps) {
      e.preventDefault();
      return false;
    }
  });
  

  $form.find('.next-step').on('click', function() {
    var $currentStepEl = $form.find('.form-step[data-step="' + currentStep + '"]');
    
    if (validateStep($currentStepEl)) {
      $form.find('.step-indicator[data-step="' + currentStep + '"]').addClass('completed');
      currentStep++;
      updateStep();
    }
  });
  

  $form.find('.prev-step').on('click', function() {
    if (currentStep > 1) {
      currentStep--;
      updateStep();
    }

    $form.find('.wpcf7-response-output').html('').attr('aria-hidden', 'true');

  });

}